export const Container = ({ children }: { children: React.ReactNode }) => {
  return <div>{children}</div>;
};
